<template>
  <div style="width: 750px;padding: 15px;position: relative;box-sizing: border-box;height: 100%;">
    
    <div style="width: 100%;position: fixed;top: 0 ;left: 50%;
    transform: translateX(-50%);
    background-color: #fff;
    padding: 15px 15px 7px;
    z-index: 9;
    max-width: 750px;
    box-sizing: border-box;
   ">
      <div style="display: flex; ">
        <van-button :type="mount == '月' ? 'danger' : 'default'" style="flex: 1;" @click="mountclick('月')">月租</van-button>
        <van-button :type="mount == '日' ? 'danger' : 'default'" style="flex: 1;" @click="mountclick('日')">日租</van-button>
      </div>
      <div class="ifnolist">
        <div class="litem1" style="background-color: #fff;"></div>
        <div class="litem">
          <div class="litemtitle" >利星行设备</div>
          <!-- <div class="litem-inp"> <van-field v-model="username" placeholder="利星行设备" /></div> -->
        </div>
        <div class="litem">
          <div  class="litemtitle">其他品牌设备</div>
          <!-- <div class="litem-inp"> <van-field v-model="username" placeholder="利星行设备" /></div> -->
        </div>
      </div>
      <div class="ifnolist">
        <div class="litem1">租赁机型</div>
        <div class="litem">
          <div class="litem-inp1"> <van-field v-model="mover1" /></div>
        </div>
        <div class="litem">
          <div class="litem-inp2"> <van-field v-model="mover2" /></div>
        </div>
      </div>
    </div>
    <div style="padding-top: 120px;padding-bottom: 110px;height: 100%;overflow-y: scroll;">
      <div style="font-size: 18px;font-weight: bold;" @click="toggleXiala">
        <img class="iconimg" v-if="isExpanded" src="https://oss-joywork.oss-accelerate.aliyuncs.com/wecom/icon/xia.png">
        <img class="iconimg" v-if="!isExpanded" src="https://oss-joywork.oss-accelerate.aliyuncs.com/wecom/icon/you.png">
        基本信息
      </div>
      <div class="xiala" :class="xialaClass">
        <div class="ifnolist">
          <div class="litem1">租期（{{ mount }}）</div>
          <div class="litem">
            <div class="litem-inp1"> <van-field v-model="tenancy1" type="number" /></div>
          </div>
          <div class="litem">
            <div class="litem-inp2"> <van-field v-model="tenancy2" type="number" /></div>
          </div>
        </div>
        <div class="ifnolist">
          <div class="litem1">租金单价（{{ mount }}/元）</div>
          <div class="litem">
            <div class="litem-inp1"> <van-field v-model="rentyue1" type="number" /></div>
          </div>
          <div class="litem">
            <div class="litem-inp2"> <van-field v-model="rentyue2" type="number" /></div>
          </div>
        </div>
        <div class="ifnolist">
          <div class="litem1">设备工作小时数（{{ mount }}）</div>
          <div class="litem">
            <div class="litem-inp1"> <van-field v-model="houryue1" type="number" /></div>
          </div>
          <div class="litem">
            <div class="litem-inp2"> <van-field v-model="houryue2" type="number" /></div>
          </div>
        </div>
        <div class="ifnolist">
          <div class="litem1">机手费用（日/元）</div>
          <div class="litem">
            <div class="litem-inp1"> <van-field v-model="jishoucost1" type="number" /></div>
          </div>
          <div class="litem">
            <div class="litem-inp2"> <van-field v-model="jishoucost2" type="number" /></div>
          </div>
        </div>
        <div class="ifnolist">
          <div class="litem1">往返运费（元）</div>
          <div class="litem">
            <div class="litem-inp1"> <van-field v-model="wangfancost1" type="number" /></div>
          </div>
          <div class="litem">
            <div class="litem-inp2"> <van-field v-model="wangfancost2" type="number" /></div>
          </div>
        </div>
        <div class="ifnolist">
          <div class="litem1">发票税率（%）</div>
          <div class="litem">
            <div class="litem-inp1"> <van-field v-model="invoice1" type="number" /></div>
          </div>
          <div class="litem">
            <div class="litem-inp2"> <van-field v-model="invoice2" type="number" /></div>
          </div>
        </div>
        <div class="ifnolist">
          <div class="litem1">设备平均油耗（升/小时）</div>
          <div class="litem">
            <div class="litem-inp1"> <van-field v-model="averagefuel1" type="number" /></div>
          </div>
          <div class="litem">
            <div class="litem-inp2"> <van-field v-model="averagefuel2" type="number" /></div>
          </div>
        </div>
        <div class="ifnolist">
          <div class="litem1">燃油单价（元/升）</div>
          <div class="litem">
            <div class="litem-inp1"> <van-field v-model="fuelprice1" type="number" /></div>
          </div>
          <div class="litem">
            <div class="litem-inp2"> <van-field v-model="fuelprice2" type="number" /></div>
          </div>
        </div>
      </div>

      <div style="font-size: 18px;font-weight: bold;" @click="togglewhith">
        <img class="iconimg" v-if="iswhithded" src="https://oss-joywork.oss-accelerate.aliyuncs.com/wecom/icon/xia.png">
        <img class="iconimg" v-if="!iswhithded" src="https://oss-joywork.oss-accelerate.aliyuncs.com/wecom/icon/you.png">
        费用详情
      </div>
      <div class="whith" :class="whithClass">
        <div class="ifnolist">
          <div class="litem1">租期总小时数</div>
          <div class="litem">
            <div class="litem-inp-dis1"> {{ zjxss1 }}</div>
          </div>
          <div class="litem">
            <div class="litem-inp-dis2">{{ zjxss2 }}</div>
          </div>
        </div>
        <div class="ifnolist">
          <div class="litem1">租金合计（元）</div>
          <div class="litem">
            <div class="litem-inp-dis1">{{ zjhj1 }}</div>
          </div>
          <div class="litem">
            <div class="litem-inp-dis2">{{ zjhj2 }}</div>
          </div>
        </div>
        <div class="ifnolist">
          <div class="litem1">租赁总油耗（升）</div>
          <div class="litem">
            <div class="litem-inp-dis1">{{ zlzyh1 }}</div>
          </div>
          <div class="litem">
            <div class="litem-inp-dis2"> {{ zlzyh2 }}</div>
          </div>
        </div>
        <div class="ifnolist">
          <div class="litem1">单{{mount}}燃油费用（元）</div>
          <div class="litem">
            <div class="litem-inp-dis1">{{ dyryfy1 }}</div>
          </div>
          <div class="litem">
            <div class="litem-inp-dis2">{{ dyryfy2 }}</div>
          </div>
        </div>
        <div class="ifnolist">
          <div class="litem1">总燃油费用合计（元）</div>
          <div class="litem">
            <div class="litem-inp-dis1">{{ zryfyhj1 }}</div>
          </div>
          <div class="litem">
            <div class="litem-inp-dis2"> {{ zryfyhj2 }}</div>
          </div>
        </div>
        <!-- <div class="ifnolist">
        <div class="litem1">发票费用（元）</div>
        <div class="litem">
          <div class="litem-inp-dis1">{{fpfy1}}</div>
        </div>
        <div class="litem">
          <div class="litem-inp-dis2"> {{fpfy2}}</div>
        </div>
      </div> -->
        <div class="ifnolist">
          <div class="litem1">机手费合计（元）</div>
          <div class="litem">
            <div class="litem-inp-dis1">{{ jsfhj1 }}</div>
          </div>
          <div class="litem">
            <div class="litem-inp-dis2">{{ jsfhj2 }}</div>
          </div>
        </div>
        <div class="ifnolist">
          <div class="litem1">往返运费（元）</div>
          <div class="litem">
            <div class="litem-inp-dis1">{{ wfyf1 }}</div>
          </div>
          <div class="litem">
            <div class="litem-inp-dis2"> {{ wfyf2 }}</div>
          </div>
        </div>
        <div class="ifnolist">
          <div class="litem1">总支出费用合计（元）</div>
          <div class="litem">
            <div class="litem-inp-dis1"> {{ zzcfyhj1 }}</div>
          </div>
          <div class="litem">
            <div class="litem-inp-dis2"> {{ zzcfyhj2 }}</div>
          </div>
        </div>
        <div class="ifnolist">
          <div class="litem1">可抵扣费用（元）</div>
          <div class="litem">
            <div class="litem-inp-dis1">{{ kdkfy1 }}</div>
          </div>
          <div class="litem">
            <div class="litem-inp-dis2">{{ kdkfy2 }} </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bomred">
      <div class="ifnolist">
        <div class="litem1">客户实际承担成本（元）</div>
        <div class="litem">
          <div class="litem-inp-dis1 redfont">{{ khsjcdcb1 }} </div>
        </div>
        <div class="litem">
          <div class="litem-inp-dis2 redfont">{{ khsjcdcb2 }} </div>
        </div>
      </div>
      <div class="ifnolist">
        <div class="litem1-1">对比结果</div>
        <div style="flex:2;">
          <div class="litem-inp-dis3" :class="dbjg1 <= 0 ? 'lvse' : 'redfont'">{{ dbjg1 }} </div>
          <!-- <div class="litemtbox">
            <div class="litem-text redfont">{{ dbjg2 }}</div>
          </div> -->
        </div>
      </div>
      <div class="ifnolist">
        <div class="litem1" style="background-color: #fff;"></div>


      </div>
      <div style="
  max-width: 750px;
    height: 50px;background-color: red;justify-content: center;
    display: flex;align-items: center;color: #fff;font-size: 14px;
    " @click="jisuankaishi">
      开始计算
    </div>
    </div>
  
   
    <!-- <div style="position: fixed;bottom: 0; left:50% ;width: 100%;z-index: 9;transform: translateX(-50%); max-width: 750px;height: 60px;background-color: #fff;">
      <van-button type="danger" style="width: 100%;height: 100%; position: relative;top: -18px;" @click="jisuankaishi">开始计算</van-button>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      mount: '月',
      mover1: '',
      mover2: '',
      tenancy1: '',
      tenancy2: '',
      rentyue1: '',
      rentyue2: '',
      houryue1: '',
      houryue2: '',
      jishoucost1: '',
      jishoucost2: '',
      wangfancost1: '',
      wangfancost2: '',
      invoice1: '',
      invoice2: '',
      averagefuel1: '',
      averagefuel2: '',
      fuelprice1: '',
      fuelprice2: '',
      // 费用详情
      zjxss1: 0,
      zjxss2: 0,
      zjhj1: 0,
      zjhj2: 0,
      zlzyh1: 0,
      zlzyh2: 0,
      dyryfy1: 0,
      dyryfy2: 0,
      zryfyhj1: 0,
      zryfyhj2: 0,
      fpfy1: 0,
      fpfy2: 0,
      jsfhj1: 0,
      jsfhj2: 0,
      wfyf1: 0,
      wfyf2: 0,
      zzcfyhj1: 0,
      zzcfyhj2: 0,
      kdkfy1: 0,
      kdkfy2: 0,
      khsjcdcb1: 0,
      khsjcdcb2: 0,
      dbjg1: 0,
      dbjg2: '',

      // 
      isExpanded: true,
      isAnimating: false,
      iswhithded: true,
      iswhithting: false
    }
  },
  computed: {
    xialaClass() {
      return {
        'xiala-collapsed': !this.isExpanded,
        'xiala-expanded': this.isExpanded
      };
    },
    whithClass() {
      return {
        'whith-collapsed': !this.iswhithded,
        'whith-expanded': this.iswhithded
      };
    },

  },
  methods: {
    // 计算
    jisuankaishi() {
      const requiredFields = [
        'mover1', 'mover2', 'tenancy1', 'tenancy2',
        'rentyue1', 'rentyue2', 'houryue1', 'houryue2',
        'jishoucost1', 'jishoucost2', 'wangfancost1', 'wangfancost2',
        'invoice1', 'invoice2', 'averagefuel1', 'averagefuel2',
        'fuelprice1', 'fuelprice2'
      ];

      // 检查每个字段是否为空
      const emptyFields = [];

      requiredFields.forEach(field => {
        if (!this[field] || this[field].toString().trim() === '') {
          emptyFields.push(field);
        }
      });

      // 如果有空字段，提示用户并停止执行
      if (emptyFields.length > 0) {
        alert(`以下字段不能为空：${emptyFields.join(', ')}`);
        return false;
      }
      //计算日租月租
      // 租期总小时数
      this.zjxss1 = this.tenancy1 * this.houryue1
      this.zjxss2 = this.tenancy2 * this.houryue2
      // 租金合计（元）
      this.zjhj1 = this.rentyue1 * this.tenancy1
      this.zjhj2 = this.rentyue2 * this.tenancy2
      // 租赁总油耗（升）
      this.zlzyh1 = this.averagefuel1 * this.houryue1 * this.tenancy1
      this.zlzyh2 = this.averagefuel2 * this.houryue2 * this.tenancy2
      // 单月燃油费用（元）
      this.dyryfy1 = this.averagefuel1 * this.fuelprice1 * this.houryue1
      this.dyryfy2 = this.averagefuel2 * this.fuelprice2 * this.houryue2
      // 总燃油费用合计（元）
      this.zryfyhj1 = this.averagefuel1 * this.fuelprice1 * (this.tenancy1 * this.houryue1)
      this.zryfyhj2 = this.averagefuel2 * this.fuelprice2 * (this.tenancy2 * this.houryue2)
      // 发票费用（元）
      this.fpfy1 = Math.round((this.rentyue1 * this.tenancy1) * (1 + (this.invoice1 / 100)) - (this.rentyue1 * this.tenancy1))
      this.fpfy2 = Math.round((this.rentyue2 * this.tenancy2) * (1 + (this.invoice2 / 100)) - (this.rentyue2 * this.tenancy2))
      // 往返运费（元）
      this.wfyf1 = Number(this.wangfancost1)
      this.wfyf2 = Number(this.wangfancost2)


      if (this.mount == '月') {
        // 机手费合计（元）
        this.jsfhj1 = this.jishoucost1 * 30 * this.tenancy1
        this.jsfhj2 = this.jishoucost2 * 30 * this.tenancy2
      }
      if (this.mount == '日') {
        // 机手费合计（元）
        this.jsfhj1 = this.jishoucost1 * this.tenancy1
        this.jsfhj2 = this.jishoucost2 * this.tenancy2
      }
      // 总支出费用合计（元）
      // this.zzcfyhj1 = this.zjhj1 + this.zryfyhj1 + this.fpfy1 + this.jsfhj1 + this.wfyf1
      // this.zzcfyhj2 = this.zjhj2 + this.zryfyhj2 + this.fpfy2 + this.jsfhj2 + this.wfyf2
      this.zzcfyhj1 = this.zjhj1 + this.zryfyhj1 + this.jsfhj1 + this.wfyf1
      this.zzcfyhj2 = this.zjhj2 + this.zryfyhj2 + this.jsfhj2 + this.wfyf2
      this.kdkfy1 = -this.fpfy1
      this.kdkfy2 = -this.fpfy2
      this.khsjcdcb1 = this.zzcfyhj1 + this.kdkfy1
      this.khsjcdcb2 = this.zzcfyhj2 + this.kdkfy2
      this.dbjg1 = this.khsjcdcb1 - this.khsjcdcb2
      if (this.dbjg1 < 0) {
        this.dbjg2 = `利星行可为客户开具13%增专票，用于税务抵扣，选择利星行租赁，客户最终实际节省成本费用${-this.dbjg1}元；`
      } else {
        this.dbjg2 = `利星行可为客户开具13%增专票，用于税务抵扣；`
      }


    },
    mountclick(e) {
      if (e != this.mount) {
        this.mover1 = '';
        this.mover2 = '';
        this.tenancy1 = '';
        this.tenancy2 = '';
        this.rentyue1 = '';
        this.rentyue2 = '';
        this.houryue1 = '';
        this.houryue2 = '';
        this.jishoucost1 = '';
        this.jishoucost2 = '';
        this.wangfancost1 = '';
        this.wangfancost2 = '';
        this.invoice1 = '';
        this.invoice2 = '';
        this.averagefuel1 = '';
        this.averagefuel2 = '';
        this.fuelprice1 = '';
        this.fuelprice2 = '';
        // ---------费用详情
        this.zjxss1 = 0;
        this.zjxss2 = 0;
        this.zjhj1 = 0;
        this.zjhj2 = 0;
        this.zlzyh1 = 0;
        this.zlzyh2 = 0;
        this.dyryfy1 = 0;
        this.dyryfy2 = 0;
        this.zryfyhj1 = 0;
        this.zryfyhj2 = 0;
        this.fpfy1 = 0;
        this.fpfy2 = 0;
        this.jsfhj1 = 0;
        this.jsfhj2 = 0;
        this.wfyf1 = 0;
        this.wfyf2 = 0;
        this.zzcfyhj1 = 0;
        this.zzcfyhj2 = 0;
        this.kdkfy1 = 0;
        this.kdkfy2 = 0;
        this.khsjcdcb1 = 0;
        this.khsjcdcb2 = 0;
        this.dbjg1 = 0;
        this.dbjg2 = '';



      }
      this.mount = e
    },
    toggleXiala() {
      if (this.isAnimating) return;

      this.isAnimating = true;
      this.isExpanded = !this.isExpanded;

      setTimeout(() => {
        this.isAnimating = false;
      }, 500);
    },
    togglewhith() {
      if (this.iswhithting) return;

      this.iswhithting = true;
      this.iswhithded = !this.iswhithded;

      setTimeout(() => {
        this.iswhithting = false;
      }, 500);
    },

  }

}
</script>

<style scoped>
.xiala {
  transition: all 0.5s ease;
  overflow: hidden;
}
.litemtitle{
  font-size: 14px;
  font-weight: 600;
}
.xiala-expanded {
  /* max-height: 1000px; 足够大的值确保能容纳所有内容 */
  opacity: 1;
}

.xiala-collapsed {
  max-height: 0;
  opacity: 0;
}

/* 基本信息标题可点击样式 */
.xiala~div[style*="font-size: 18px"] {
  cursor: pointer;
}

.whith {
  /* margin-bottom: 110px; */
  transition: all 0.5s ease;
  overflow: hidden;
}

.whith-expanded {
  /* max-height: 1000px; 足够大的值确保能容纳所有内容 */
  opacity: 1;
}

.whith-collapsed {
  max-height: 0;
  opacity: 0;
}

/* 基本信息标题可点击样式 */
.whith~div[style*="font-size: 18px"] {
  cursor: pointer;
}

.ifnolist {
  display: flex;
  font-size: 14px;
  font-weight: 600;
  margin-top: 7px;
  text-align: center;


}

.litem {
  flex: 1;

}

.litem1 {
  flex: 1.8;
  background-color: #FBAC01;
  line-height: 26px;
  margin-right: 10px;
  padding-left: 5px;
  box-sizing: border-box;
}

.litem1-1 {
  flex: 1.8;
  background-color: #FBAC01;
  margin-right: 10px;
  padding-left: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.litem-inp1 {
  /* border: 1px solid #999; */
  background-color: #F9F4C8;
  margin-right: 5px;

}

.litem-inp2 {
  /* border: 1px solid #999; */
  background-color: #F9F4C8;
  margin-left: 5px;

}

.litem-inp-dis1 {
  /* border: 1px solid #999; */
  margin-right: 5px;
  background-color: #F9F4C8;
  height: 26px;
  line-height: 26px;
  /* padding-left: 10px; */
}

.litem-inp-dis2 {
  /* border: 1px solid #999; */
  margin-left: 5px;
  background-color: #F9F4C8;
  height: 26px;
  line-height: 26px;
  /* padding-left: 10px; */

}

.litem-inp-dis3 {
  background-color: #F9F4C8;
  height: 26px;
  line-height: 26px;
  padding-left: 10px;
  text-align: center;
  /* margin-bottom: 7px; */
}

.bomred {
  position: fixed;
  bottom: 0px;
  left: 50%;
  width: 100%;
  z-index: 9;
  transform: translateX(-50%);
  max-width: 750px;
  background-color: #fff;
  padding: 0 15px;
  box-sizing: border-box;
}

.bomred .redfont {
  color: red;
}

.bomred .lvse {
  color: #0DED58;
}

.whith .litem1 {
  color: #fff;
}

.bomred .van-field__control:disabled {
  /* color: red; */
  /* -webkit-text-fill-color: red; */
}

.litemtbox {
  flex: 2;
}

.litem-text {
  /* border: 1px solid #999; */
  background-color: #F9F4C8;
  min-height: 50px;
  padding: 10px;
}

.van-cell {
  padding: 0px 0px 0 10px;
  background-color: transparent
}

.iconimg {
  width: 20px;
}</style>
<style>
.litem-inp1 .van-field__control {
  text-align: center !important;
  justify-content: center;
  display: flex;
  align-items: center;
}
.litem-inp2 .van-field__control {
  text-align: center !important;
  justify-content: center;
  display: flex;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/pages/qiwei/valuelease/index.vue